import { useState, useCallback } from 'react';
import moment from 'moment';
import { importTanomuDeliveryCsv, TanomuImportError } from 'api/tanomuCsvImport';
import useToastNotification from 'hooks/useToastNotification';

const useTanomuCsvImport = () => {
  const [importDate, setImportDate] = useState<Date>(new Date());
  const [existData, setExistData] = useState<number>(1);
  const [uploadFile, setUploadFile] = useState<File | undefined>(undefined);
  const [inputValue, setInputValue] = useState('');
  const [errors, setErrors] = useState<string[] | undefined>(undefined);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [blocking, setBlocking] = useState(false);

  const { successNotification, errorNotification } = useToastNotification();

  const handleFileChange = useCallback((file: File | undefined) => {
    setUploadFile(file);
    setErrors(undefined);
  }, []);

  const handleSubmit = useCallback(() => {
    setConfirmModalOpen(true);
  }, []);

  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  const onSubmit = useCallback(() => {
    setConfirmModalOpen(false);
    if (!uploadFile) return;

    setErrors(undefined);
    setBlocking(true);

    const formattedDate = moment(importDate).format('YYYY-MM-DD');

    importTanomuDeliveryCsv(formattedDate, existData, uploadFile)
      .then(() => {
        setBlocking(false);
        successNotification('インポートが完了しました。');
        setUploadFile(undefined);
        setInputValue('');
      })
      .catch((error: any) => {
        setBlocking(false);
        if (error.response?.data?.errors) {
          setErrors(
            (error.response.data.errors as TanomuImportError[]).map((e) => e.defaultMessage),
          );
        } else {
          errorNotification('サーバー側でエラーが発生しました。');
        }
      });
  }, [errorNotification, existData, importDate, successNotification, uploadFile]);

  const optionsExistData = [
    { label: '上書き', value: '1' },
    { label: '加算', value: '0' },
  ];

  return {
    importDate,
    setImportDate,
    existData,
    setExistData,
    uploadFile,
    setUploadFile: handleFileChange,
    inputValue,
    setInputValue,
    errors,
    confirmModalOpen,
    closeConfirmModal,
    handleSubmit,
    onSubmit,
    blocking,
    optionsExistData,
  };
};

export default useTanomuCsvImport;
